const IdentificationMethodsARSValidationRules = new Map([
    [
        'DNI',
        {
            minLength: 7,
            maxLength: 8,
        },
    ],
    [
        'CI',
        {
            minLength: 1,
            maxLength: 9,
        },
    ],
    [
        'LC',
        {
            minLength: 6,
            maxLength: 7,
        },
    ],
    [
        'LE',
        {
            minLength: 6,
            maxLength: 7,
        },
    ],
    [
        'Otro',
        {
            minLength: 5,
            maxLength: 20,
        },
    ],
]);

const IS_NON_NEGATIVE_INTEGER_REGEX = new RegExp('^\\d+$');

/**
 * Validator: Test that a value is a valid Argentinian identification number
 * [according to Mercadopago identification types](https://www.mercadopago.com.ar/developers/es/reference/identification_types/_identification_types/get)
 * @param value {string} the identification number to validate
 * @param identificationMethod {string} one of ['DNI', 'CI', 'LC', 'LE', 'Otro']
 * @returns {boolean} is str a valid identification number.
 */
export const isValidIdentificationMethodARS = (value, identificationMethod) =>
    IS_NON_NEGATIVE_INTEGER_REGEX.test(value) &&
    IdentificationMethodsARSValidationRules.has(identificationMethod) &&
    value.length >=
        IdentificationMethodsARSValidationRules.get(identificationMethod)
            .minLength &&
    value.length <=
        IdentificationMethodsARSValidationRules.get(identificationMethod)
            .maxLength;
